import { Component } from '@angular/core';

@Component({
  selector: 'app-community-service-search',
  templateUrl: './community-service-search.component.html',
  styleUrls: ['./community-service-search.component.scss']
})
export class CommunityServiceSearchComponent
{

}
